export default {
  title: 'Adicionar ficheiro: {{slot}}',
  replace_title: 'Substituir ficheiro: {{slot}}',
  replace_description: 'O novo ficheiro substitui este. Mantemos o antigo nos nossos registos.',
  form: {
    kind: {
      label: 'Tipo de identificação',
      options: {
        passport: 'Passaporte',
        driver_license: 'Carta de condução',
        id_card: 'Cartão de cidadão',
        residence_permit: 'Autorização de residência',
      },
    },
    front: {
      label: 'Frente',
    },
    back: {
      label: 'Verso',
    },
    file: {
      label: 'Ficheiro',
    },
    expires_at: {
      label: 'Válido até',
      placeholder: 'Selecione uma data',
    },
    holder: {
      label: 'De quem é esta identificação?',
      options: {
        owner: 'Minha, do proprietário',
        partner: 'De um sócio',
      },
    },
    holder_name: {
      label: 'Nome do sócio',
      placeholder: 'Nome e apelido',
    },
  },
  accepted_files: 'PDF, JPG ou PNG, até {{max}} MB.',
  accepted_images_min: 'Uma foto deve ter pelo menos {{min}} KB.',
  errors: {
    file_type: 'Apenas são aceites ficheiros PDF, JPG ou PNG.',
    file_too_large: 'O ficheiro é maior do que {{max}} MB.',
    file_too_small: 'Uma foto deve ter pelo menos {{min}} KB.',
  },
  buttons: {
    select_file: 'Selecionar ficheiro',
    submit: 'Carregar',
    cancel: 'Cancelar',
  },
  toasts: {
    success: 'Ficheiro carregado',
    error: 'Não foi possível carregar o ficheiro.',
  },
};
